/* this file is transformed by vux-loader */
/* eslint-disable */
export default {
  cer_s1: '点击按钮',
  cer_s2: '开始录制',
  cer_s3: '保持正脸',
  cer_s4: '屏幕居中',
  cer_s5: '智能身份',
  cer_s6: '识别结果',
  vertification_name: '认证人',
  idcard: '身份证号',
  begin: '开始',
  ver_comfirm: '请确保为',
  self_operate: '本人操作',
  agreement: '我已认真阅读并同意认证授权',
  vertification_tips: '请先同意认证授权',
  cer_success: '实名认证完成',
  cer_fail: '实名认证失败',
  check_patient_info: '查看个人资料',
  vertification_again: '重新认证',
  vertificationing: '实名认证中...',
  receive_success: '领取成功'
};